module.exports = __webpack_public_path__ + "static/media/2_.426fa515.png";